/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

var head;

// 获取元素的纵坐标（相对于窗口）
function getTop(e){
  var offset=e.offsetTop;
  if(e.offsetParent!=null) offset+=getTop(e.offsetParent);
  return offset;
}

$.gridify = function (table, opt,getGanttId,topHeight) {
  var options = {
    resizeZoneWidth: 10
  };

  $.extend(options, opt);

  var box = $("<div>").addClass("gdfWrapper");
  box.append(table);
  head = table.clone();
  table.addClass("rowDragTable");
  //处理table避免左右滚动不平衡
  table.find('thead').find('tr').height('0px');
  table.find('thead').find('tr').find('th').height('0px');
  table.find('thead').find('tr').find('th').css('border-bottom','none');
  table.find('thead').find('tr').find('th').each((index,item)=>{item.innerHTML='';});
  table.css('margin-top','60px');

  head.addClass("table ganttFixHead");
  head.css('position','fixed');
  head.css('top',topHeight+2);
  //remove non head
  head.find("tbody").remove();
  box.append(head);

  box.append(table);

  var hTh = head.find(".gdfColHeader");
  var cTh = table.find(".gdfColHeader");
  for (var i = 0; i < hTh.length; i++) {
    hTh.eq(i).data("fTh", cTh.eq(i));
  }

  //--------- set table to 0 to prevent a strange 100%
  table.width(0);
  head.width(0);


  //----------------------  header management start
  head.find("th.gdfColHeader:not(.gdfied)").mouseover(function () {
    $(this).addClass("gdfColHeaderOver");

  }).on("mouseout.gdf", function () {
    $(this).removeClass("gdfColHeaderOver");
    if (!$.gridify.columInResize) {
      $(`.TWGanttWorkSpace_${getGanttId}`).removeClass("gdfHResizing");
    }

  }).on("mousemove.gdf", function (e) {
    if (!$.gridify.columInResize) {
      var colHeader = $(this);
      var nextCol = colHeader.next();
      if (nextCol.length > 0 && nextCol.width() < options.resizeZoneWidth)
        colHeader = nextCol;

      if (!colHeader.is(".gdfResizable"))
        return;

      var mousePos = e.pageX - colHeader.offset().left;

      if (colHeader.width() - mousePos < options.resizeZoneWidth) {
        $(`.TWGanttWorkSpace_${getGanttId}`).addClass("gdfHResizing");
      } else {
        $(`.TWGanttWorkSpace_${getGanttId}`).removeClass("gdfHResizing");
      }
    }

  }).on("mousedown.gdf", function (e) {
    //console.debug("mousedown.gdf")
    var colHeader = $(this);

    var nextCol = colHeader.next();
    if (nextCol.length > 0 && nextCol.width() < options.resizeZoneWidth)
      colHeader = nextCol;

    if (!colHeader.is(".gdfResizable"))
      return;

    var mousePos = e.pageX - colHeader.offset().left;
    if (colHeader.width() - mousePos < options.resizeZoneWidth) {
      $.gridify.columInResize = colHeader;
      //on event for start resizing
      $(document).on("mousemove.gdf", function (e) {

        e.preventDefault();
        $(`.TWGanttWorkSpace_${getGanttId}`).addClass("gdfHResizing");

        //manage resizing
        var w = e.pageX - $.gridify.columInResize.offset().left;
        w = w <= 1 ? 1 : w;
        $.gridify.columInResize.width(w);
        $.gridify.columInResize.data("fTh").width(w);
        //on mouse up on body to stop resizing
        moveSplitBar(getGanttId);
      }).on("mouseup.gdf", function () {
        //console.debug("mouseup.gdf")
        $(this).off("mousemove.gdf").off("mouseup.gdf");
        $(`.TWGanttWorkSpace_${getGanttId}`).removeClass("gdfHResizing");
        delete $.gridify.columInResize;

        $('th[data-initialwidth]').attr('data-initialwidth',$('th[data-initialwidth]').outerWidth());
      });
    }

  }).on("dblclick.gdf", function () {
    //console.debug("dblclick.gdf")
    var col = $(this);

    if (!col.is(".gdfResizable"))
      return;

    var idx = $("th", col.parents("table")).index(col);
    var columnTd = $("td:nth-child(" + (idx + 1) + ")", table);
    var w = 0;
    columnTd.each(function () {
      var td = $(this);
      var content = td.children("input").length ? td.children("input").val() : td.html();
      var tmp = $("<div/>").addClass("columnWidthTest").html(content).css({position: "absolute"});
      $(`.TWGanttWorkSpace_${getGanttId}`).append(tmp);
      w = Math.max(w, tmp.width() + parseFloat(td.css("padding-left")));
      tmp.remove();
    });

    w = w + 5;
    col.width(w);
    col.data("fTh").width(w);

    extendLastTh();
    return false;

  }).addClass("gdfied unselectable");
  return box;
};

//改为延长标题字段
function extendLastTh(getGanttId,opt){
  //如果box1不存在滚动条则通过动态该表标题字段的宽度来适应box1的展示效果
  var titleField=$(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox1').find('.ganttFixHead th[data-initialwidth]');//标题字段，需要延长的字段
  var initialwidth=titleField.attr('data-initialwidth');//最后一个th的原始长度
  //当标题字段的宽度小于自身原始宽度时就不在调整
  if(titleField.outerWidth()>=initialwidth){
    if(opt){//点击按钮触发
      var difWidth=opt.newW-$(`.TWGanttWorkSpace_${getGanttId}`).find('.ganttFixHead').outerWidth()-3+parseInt(titleField.outerWidth());
      if(difWidth<initialwidth)difWidth=initialwidth;
        $(`.TWGanttWorkSpace_${getGanttId}`).find('.gdfTable th[data-initialwidth]').animate({width: difWidth}, opt.animTime);
    }else{//拖动触发
      //获取box1的宽度与splitbar的left的差值+标题字段的现有宽度
      var difWidth=$(`.TWGanttWorkSpace_${getGanttId}`).find('.vSplitBar').css('left').replace('px','')-$(`.TWGanttWorkSpace_${getGanttId}`).find('.ganttFixHead').outerWidth()-3+parseInt(titleField.outerWidth());
      if(difWidth<initialwidth)difWidth=initialwidth;
      $(`.TWGanttWorkSpace_${getGanttId}`).find('.gdfTable th[data-initialwidth]').outerWidth(difWidth);
    }
  }
}

//左边table补齐空白
function moveSplitBar(getGanttId){
  var barLeft=$(`.TWGanttWorkSpace_${getGanttId}`).find('.vSplitBar').css('left').replace('px','');
  var difWidth=barLeft-$(`.TWGanttWorkSpace_${getGanttId}`).find('.ganttFixHead').outerWidth()-3;
  if(difWidth>0){
    $(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox1').width($(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox1').width()-difWidth);
    $(`.TWGanttWorkSpace_${getGanttId}`).find('.vSplitBar').css('left',$(`.TWGanttWorkSpace_${getGanttId}`).find('.vSplitBar').css('left').replace('px','')-difWidth);
    $(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox2').width($(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox2').width()+difWidth);
    $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').width($(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').width()+difWidth);
    $(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox2').css('left',$(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox2').css('left').replace('px','')-difWidth);
  }


}


$.splittify = {
  init: function (where, first, second, perc,getGanttId) {
    //perc = perc || 50;

    var element = where.find('.splitterContainer');//$("<div>").addClass("splitterContainer");
    var firstBox = $("<div>").addClass("splitElement splitBox1");
    var splitterBar = $("<div>").addClass("splitElement vSplitBar").css("padding-top", where.height() / 2 + "px");
    var secondBox = $("<div>").addClass("splitElement splitBox2");

    var splitter = new Splitter(element, firstBox, secondBox, splitterBar,getGanttId);
    splitter.perc =  perc;

    var toLeft = $("<div>").addClass("toLeft icon-coms-Left").click(function () {splitter.resize(0.001, 300);});
    splitterBar.append(toLeft);

    var toCenter = $("<div>").addClass("toCenter icon-coms-Refresh").click(function () {splitter.resize(50, 300);});
    splitterBar.append(toCenter);

    var toRight = $("<div>").addClass("toRight icon-coms-Right").click(function () {splitter.resize(99.9999, 300);});
    splitterBar.append(toRight);


    firstBox.append(first);
    secondBox.append(second);
    element.append(firstBox).append(secondBox).append(splitterBar);
    if ($('.splitBox1')[0]) {
      // head.css('top',getTop($('.splitBox1')[0])+2);
      head.css('top',getTop($('.splitBox1')[0]));
    }
    //where.append(element);
    var totalW = where.innerWidth();
    var splW = splitterBar.width();
    var fbw = totalW * perc / 100 - splW;
    fbw = fbw > totalW - splW - splitter.secondBoxMinWidth ? totalW - splW - splitter.secondBoxMinWidth : fbw;

    firstBox.width(fbw).css({left: 0});
    splitterBar.css({left: firstBox.width()});
    secondBox.width(totalW - fbw - splW).css({left: firstBox.width() + splW});

    splitterBar.on("mousedown.gdf", function (e) {

      e.preventDefault();
      $(`.TWGanttWorkSpace_${getGanttId}`).addClass("gdfHResizing");

      $.splittify.splitterBar = $(this);
      //on event for start resizing
      //console.debug("start splitting");
      $(`.TWGanttWorkSpace_${getGanttId}`).on("mousemove.gdf", function (e) {
        //manage resizing
        e.preventDefault();
        totalW=$(`.TWGanttWorkSpace_${getGanttId}`).find('.TWGanttArea').innerWidth();
        var sb = $.splittify.splitterBar;
        var pos = e.pageX - sb.parent().offset().left;
        var w = sb.parent().width();

        pos = pos > splitter.firstBoxMinWidth ? pos : splitter.firstBoxMinWidth;
        //pos = pos < realW - 10 ? pos : realW - 10;
        pos = pos > totalW - splW - splitter.secondBoxMinWidth ? totalW - splW - splitter.secondBoxMinWidth : pos;
        sb.css({left: pos});

        firstBox.width(pos);
        secondBox.css({left: pos + sb.width(), width: w - pos - sb.width()});
        $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').width(secondBox.width());
        splitter.perc = (firstBox.width() / splitter.element.width()) * 100;
        extendLastTh(getGanttId);
        //on mouse up on body to stop resizing
      }).on("mouseup.gdf", function () {
        //console.debug("stop splitting");
        $(this).off("mousemove.gdf").off("mouseup.gdf");
        delete $.splittify.splitterBar;

        $(`.TWGanttWorkSpace_${getGanttId}`).removeClass("gdfHResizing");
      });
    });

    firstBox.on('mousewheel MozMousePixelScroll', function (event) {

      event.preventDefault();

      var deltaY = event.originalEvent.wheelDeltaY;
      if (!deltaY)
        deltaY = event.originalEvent.wheelDelta;
      var deltaX = event.originalEvent.wheelDeltaX;

      if (event.originalEvent.axis) {
        deltaY = event.originalEvent.axis == 2 ? -event.originalEvent.detail : null;
        deltaX = event.originalEvent.axis == 1 ? -event.originalEvent.detail : null;
      }

      deltaY = Math.abs(deltaY) < 40 ? 40 * (Math.abs(deltaY) / deltaY) : deltaY;
      deltaX = Math.abs(deltaX) < 40 ? 40 * (Math.abs(deltaX) / deltaX) : deltaX;

      var scrollToY = $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').scrollTop()- deltaY;//secondBox.scrollTop() - deltaY;
      var scrollToX = firstBox.scrollLeft() - deltaX;

//			console.debug( firstBox.scrollLeft(), Math.abs(deltaX), Math.abs(deltaY));

      if (deltaY) $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').scrollTop(scrollToY);//secondBox.scrollTop(scrollToY);
      if (deltaX) firstBox.scrollLeft(scrollToX);

      return false;
    });

    function Splitter(element, firstBox, secondBox, splitterBar,getGanttId) {
      this.element = element;
      this.firstBox = firstBox;
      this.secondBox = secondBox;
      this.splitterBar = splitterBar;
      this.perc = 0;
      this.firstBoxMinWidth = 0;
      this.secondBoxMinWidth = 30;
      var self = this;
      this.resize = function (newPerc, anim) {
        var animTime = anim ? anim : 0;
        this.perc = newPerc ? newPerc : this.perc;
        var totalW = this.element.width();
        var splW = this.splitterBar.width();
        var newW = totalW * this.perc / 100;
        newW = newW > this.firstBoxMinWidth ? newW : this.firstBoxMinWidth;
        newW = newW > totalW - splW - splitter.secondBoxMinWidth ? totalW - splW - splitter.secondBoxMinWidth : newW;
        if(!newPerc&&!anim){//初始加载时执行
          var realW=$(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox1').find('.ganttFixHead').width()+splW+1-3;
          newW=newW<realW?newW:realW;
        }

        this.firstBox.animate({width: newW}, animTime, function () {$(this).css("overflow-x", "auto");});
        this.splitterBar.animate({left: newW}, animTime);
        extendLastTh(getGanttId,{newW,animTime});
        this.secondBox.animate({left: newW + this.splitterBar.width(), width: totalW - newW - splW}, animTime, function () {
          $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').width(self.secondBox.width())
        });
      };

      this.splitterBar.on("dblclick", function () {
        self.resize(50, true);
      })
    }



    return splitter;
  }

};


//<%------------------------------------------------------------------------  UTILITIES ---------------------------------------------------------------%>
// same dates returns 1
window.getDurationInUnits=function(start,end){
  return start.distanceInWorkingDays(end)+1; // working in days
}

//con due date uguali ritorna 0: usata per cancolare la distanza effettiva tra due date
window.getDistanceInUnits=function(date1,date2){
  return date1.distanceInWorkingDays(date2); // working in days
}

window.incrementDateByUnits=function(date,duration){
  date.incrementDateByWorkingDays(duration); // working in days
  return date;
}


window.computeStart=function (start) {
  return computeStartDate(start).getTime();
}

/**
 * @param start
 * @returns {Date} the closes start date
 */
window.computeStartDate=function (start) {
  var d = new Date(start);
  d.setHours(0, 0, 0, 0);
  //move to next working day
  while (isHoliday(d)) {
    d.setDate(d.getDate() + 1);
  }
  d.setHours(0, 0, 0, 0);
  return d;
}

window.computeEnd=function (end) {
  return computeEndDate(end).getTime()
}

/**
 * @param end
 * @returns {Date} the closest end date
 */
window.computeEndDate=function (end) {
  var d = new Date(end);
  d.setHours(23, 59, 59, 999);
  //move to next working day
  while (isHoliday(d)) {
    d.setDate(d.getDate() + 1);
  }
  d.setHours(23, 59, 59, 999);
  return d;
}

window.computeEndByDuration=function (start, duration) {
  var d = new Date(start);
  var q = duration - 1;
  while (q > 0) {
    d.setDate(d.getDate() + 1);
    if (!isHoliday(d))
      q--;
  }
  d.setHours(23, 59, 59, 999);
  return d.getTime();
}


window.incrementDateByWorkingDays=function (date, days) {
  var d = new Date(date);
  d.incrementDateByWorkingDays(days);
  return d.getTime();
}


window.recomputeDuration=function (start, end) {
  //console.debug("recomputeDuration");
  return getDurationInUnits(new Date(start),new Date(end));
}

function resynchDates(leavingField, startField, startMilesField, durationField, endField, endMilesField) {
  //console.debug("resynchDates",leavingField.prop("name"), "start. "+startField.val(),"durationField: "+ durationField.val(), "endField: "+endField.val());

  function resynchDatesSetFields(command) {
    //console.debug("resynchDatesSetFields",command);
    var duration = stringToDuration(durationField.val());
    var start = computeStart(Date.parseString(startField.val()).getTime());

    var end = endField.val();
    if (end.length > 0) {
      end = Date.parseString(end);
      end.setHours(23, 59, 59, 999); //this is necessary because compute end get the closest end, and parseString returns 00:00
      end = computeEnd(end.getTime());
    }

    var date = new Date();
    if ("CHANGE_END" == command) {
      date.setTime(start);
      var workingUnits = duration-1; // if we do not decremet a task lasting two days starting on 10 will end on 12 (at 00:00) instead of on (at 23:59)
      incrementDateByUnits(date,workingUnits);
      date.setHours(23, 59, 59, 999); //this is necessary because compute end get the closest end, and parseString returns 00:00
      end = computeEnd(date.getTime()); // not strictly necessary
    } else if ("CHANGE_START" == command) {
      date.setTime(end);
      var workingUnits = duration - 1; // if we do not decremet a task lasting two days starting on 10 will end on 12 (at 00:00) instead of on (at 23:59)
      incrementDateByUnits(date,-workingUnits);
      date.setHours(0, 0, 0, 0); //this is necessary because decreasing end we are at 23:50
      start = computeStart(date.getTime()); //not strictly necessary
    } else if ("CHANGE_DURATION" == command) {
      duration = getDurationInUnits(new Date(start),new Date(end)) + 1; 
    }

    startField.val(new Date(start).format());
    endField.val(new Date(end).format());
    durationField.val(duration);

    return {start: start, end: end, duration: duration};
  }

  var leavingFieldName = leavingField.prop("name");
  var durIsFilled = durationField.val().length > 0;
  var startIsFilled = startField.val().length > 0;
  var endIsFilled = endField.val().length > 0;
  var startIsMilesAndFilled = startIsFilled && (startMilesField.prop("checked") || startField.is("[readOnly]"));
  var endIsMilesAndFilled = endIsFilled && (endMilesField.prop("checked") || endField.is("[readOnly]"));

  if (durIsFilled) {
    durationField.val(stringToDuration(durationField.val()));
  }

  if (leavingFieldName.indexOf("Milestone") > 0) {
    if (startIsMilesAndFilled && endIsMilesAndFilled) {
      durationField.prop("readOnly", true);
    } else {
      durationField.prop("readOnly", false);
    }
    return;
  }

  //need at least two values to resynch the third
  if ((durIsFilled ? 1 : 0) + (startIsFilled ? 1 : 0) + (endIsFilled ? 1 : 0) < 2)
    return;

  var ret;
  if (leavingFieldName == 'start' && startIsFilled) {
    if (endIsMilesAndFilled && durIsFilled) {
      ret = resynchDatesSetFields("CHANGE_DURATION");
    } else if (durIsFilled) {
      ret = resynchDatesSetFields("CHANGE_END");
    }

  } else if (leavingFieldName == 'duration' && durIsFilled && !(endIsMilesAndFilled && startIsMilesAndFilled)) {
    if (endIsMilesAndFilled && !startIsMilesAndFilled) {
      ret = resynchDatesSetFields("CHANGE_START");
    } else if (!endIsMilesAndFilled) {
      //document.title=('go and change end!!');
      ret = resynchDatesSetFields("CHANGE_END");
    }

  } else if (leavingFieldName == 'end' && endIsFilled) {
    ret = resynchDatesSetFields("CHANGE_DURATION");
  }
  return ret;
}


//This prototype is provided by the Mozilla foundation and
//is distributed under the MIT license.
//http://www.ibiblio.org/pub/Linux/LICENSES/mit.license

if (!Array.prototype.filter) {
  Array.prototype.filter = function (fun) {
    var len = this.length;
    if (typeof fun != "function")
      throw new TypeError();

    var res = new Array();
    var thisp = arguments[1];
    for (var i = 0; i < len; i++) {
      if (i in this) {
        var val = this[i]; // in case fun mutates this
        if (fun.call(thisp, val, i, this))
          res.push(val);
      }
    }
    return res;
  };
}

window.stringToDuration=function (durStr) {
  var duration = NaN;
  duration = daysFromString(durStr, true) || 1;
  return duration;
}

window.goToPage=function (url) {
  if (!canILeave()) return;
  window.location.href = url;
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/lib/gantt/js/ganttUtilities.js